<template lang="pug">
    #TenantCenter.main-page.TenantCenter-background.page-noScroll.pb-0.position-relative
        loadingOverlay(v-if='loading' message='Loading . . .' :zIndex='999' attach)
        div.height_100(v-if='!loading')
            div(:href='"/tenant_center/tenant_list"').d-flex.align-start.justify-start
                v-breadcrumbs.pa-0.px-3.pb-2.ellipsis()
                    v-breadcrumbs-item(v-for="item in breadcrumbs" :key="item.text" )
                        .detail_a
                            a(:href='item.href' style="color: #444;")
                                v-icon(size='23' style='margin-bottom:2px;').pr-1 mdi-chevron-double-left
                                span {{item.text}}
            div().d-flex.align-start.justify-start.pl-3
                h4 {{$t('TENANTCENTER_USER_LIST.LIST')}} - {{target_name}}
            #page-inner.pa-3.d-flex.justify-center
                v-data-table.pl-4.pr-4.mt-0(:headers="userListHeaders" :items="tenantUserItems")
                    template( v-slot:item.id="{ item }" )
                        .ellipsis
                            span.ellipsis(:title='item.id') {{ item.id }}
                    template( v-slot:item.username="{ item }" )
                        .ellipsis
                            span.ellipsis(:title='item.username') {{ item.username }}
                    template( v-slot:item.first_name="{ item }" )
                        .ellipsis
                            span.ellipsis(:title='item.first_name') {{ item.first_name }}
                    template( v-slot:item.last_name="{ item }" )
                        .ellipsis
                            span.ellipsis(:title='item.last_name') {{ item.last_name }}
                    template( v-slot:item.email="{ item }" )
                        .ellipsis
                            span.ellipsis(:title='item.email') {{ item.email }}
                    //- template( v-slot:item.is_superuser="{ item }" )
                    //-     .ellipsis
                    //-         v-checkbox(size="18" color='#8ae8f4' class='ellipsis ml-2' v-model='item.is_superuser' readonly :ripple='false') 
                    template( v-slot:item.is_staff="{ item }" )
                        .ellipsis
                            v-checkbox(size="18" color='#8ae8f4' class='ellipsis ml-2' v-model='item.is_staff' readonly :ripple='false') 
                    template( v-slot:item.is_active="{ item }" )
                        .ellipsis
                            v-checkbox(size="18" color='#8ae8f4' class='ellipsis ml-2' v-model='item.is_active' readonly :ripple='false') 
                    template( v-slot:item.last_login="{ item }" )
                        div(:title='getFormatTime(item.last_login)') {{ getFormatTime(item.last_login) }}
                    template( v-slot:item.date_joined="{ item }" )
                        div(:title='getFormatTime(item.date_joined)') {{ getFormatTime(item.date_joined) }}

</template>
<script>
import i18n from '/common/plugins/vue-i18n.js';
import TenantCenterService from "@/services/TenantCenterService";
export default {
    name: "TenantCente-User-List",
    components: {
        
    },
    data() {
        return{
            loading:false,
            target_name: this.$route.params.id,
            breadcrumbs: [{
              text: i18n.t('GPT_MENU.BACKTO') + i18n.t('TENANTCENTER.TENANTLIST'),
              disabled: false,
              href: '/tenant_center/tenant_list',
                }
            ],
            userListHeaders:[
                {
                    text: 'ID',
                    align: 'left',
                    sortable: false,
                    value: 'id',
                    class: "transparent .px-1",
                    width: "40px",
                },
                {
                    text: i18n.t('TENANTCENTER_USER_LIST.USERNAME'),
                    align: 'left',
                    sortable: false,
                    value: 'username',
                    class: "transparent",
                },
                {
                    text: i18n.t('TENANTCENTER_USER_LIST.FIRSTNAME'),
                    align: 'left',
                    sortable: false,
                    value: 'first_name',
                    class: "transparent",
                },
                {
                    text: i18n.t('TENANTCENTER_USER_LIST.LASTNAME'),
                    align: 'left',
                    sortable: false,
                    value: 'last_name',
                    class: "transparent",
                },
                {
                    text: i18n.t('TENANTCENTER_USER_LIST.EMAIL'),
                    align: 'left',
                    sortable: false,
                    value: 'email',
                    class: "transparent",
                },
                // {
                //     text: i18n.t('TENANTCENTER_USER_LIST.SUPERUSER'),
                //     align: 'left',
                //     sortable: false,
                //     value: 'is_superuser',
                //     width: "100px",
                //     class: "transparent",
                // },
                {
                    text: i18n.t('TENANTCENTER_USER_LIST.ADMIN'),
                    align: 'left',
                    sortable: false,
                    value: 'is_staff',
                    width: "100px",
                    class: "transparent",
                },
                {
                    text: i18n.t('TENANTCENTER_USER_LIST.ACTIVE'),
                    align: 'left',
                    sortable: false,
                    value: 'is_active',
                    width: "100px",
                    class: "transparent",
                },
                {
                    text: i18n.t('TENANTCENTER_USER_LIST.LOGIN_DATE'),
                    align: 'left',
                    sortable: false,
                    value: 'last_login',
                    width: '150px',
                    class: "transparent",
                },
                {
                    text: i18n.t('TENANTCENTER_USER_LIST.JOIN_DATE'),
                    align: 'left',
                    sortable: false,
                    value: 'date_joined',
                    width: '150px',
                    class: "transparent",
                },
            ],
            tenantUserItems:[]
        }
    },
    async created() {
        await TenantCenterService.userList(this.target_name).then(response=>{
            this.tenantUserItems = response.data;
        })

    },
    methods: {
        getFormatTime(data){
            let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',hour: '2-digit',minute: '2-digit',hour12: false };
            let today  = new Date(data);
            if(this.$i18n.locale == "zh_TW")
            {
                return today.toLocaleDateString("zh-TW", options); 
            }else
            {
                return today.toLocaleDateString("en-US", options);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
</style>